import React, {Component} from 'react';
import {DatePicker, TimePicker, Money} from 'components/UI/Form/Fields'
import moment from 'moment'

import './TicketList.scss'

class AdvanceSettings extends Component{

  constructor(props){
    super(props)

  }


  render(){
    let {startDate, startTime, endDate, endTime, price, noEndTime, auto_wait_list} = this.props.data;
    let {onChange, type} = this.props


    return(
      <div className='advance-settings-content'>
        <div className='row btn-row'>
          <div className='col-xs-12 advance-title'>{__('Advance Settings', 'ticket')}</div>
          <hr className='advance-hr' />
        </div>
        <div className='row btn-row'>
          <div className='col-xs-12 advance-label'>{__('Registration Start Time', 'ticket')}</div>
        </div>
        <div className='row btn-row'>
          <div className='col-xs-6'>
            <DatePicker value={startDate} onChange={onChange('startDate')} />
          </div>
          <div className='col-xs-6'>
            <TimePicker value={startTime} onChange={onChange('startTime')} />
          </div>
        </div>
        <div className='row btn-row'>
          <span className='advance-label'>{__('Registration End Time', 'ticket')}</span>
          <span className='no-end-time'>
            <input type='checkbox' onChange={onChange('noEndTime')} checked={noEndTime} />
            <span className='advance-label'>{__('No End Time', 'ticket')}</span>
          </span>
        </div>
        <div className='row btn-row'>
          <div className='col-xs-6'>
            <DatePicker value={endDate} onChange={onChange('endDate')} disabled={noEndTime === true} />
          </div>
          <div className='col-xs-6'>
            <TimePicker value={endTime} onChange={onChange('endTime')} disabled={noEndTime === true} />
          </div>
        </div>
        <div className='row btn-row'>
          <div className='col-xs-12 advance-label'>
            {__('Price', 'ticket')}
            {type == 'fixedAmount' && <span className='red'>*</span>}
          </div>

        </div>
        <div className='row btn-row'>
          <div className='col-xs-6'>
            <Money outputType='string' value={price} onChange={onChange('price')} />
          </div>
        </div>
        <div className='row btn-row'>
          <div className='col-xs-12 advance-label wait-list-label'>
            {__('Waiting List', 'ticket')}
            <span className='red'>*</span>
          </div>
          <div className='col-xs-12 wait-list'>
            <input type='radio' value='enterWaitList' onChange={onChange('auto_wait_list')} checked={auto_wait_list === 'enterWaitList'} />
            <span className='advance-label wait-list-input'>{__('Allow Waiting List', 'ticket')}</span>
          </div>
          <div className='col-xs-12 wait-list'>
            <input type='radio' value='noWaitList' onChange={onChange('auto_wait_list')} checked={auto_wait_list === 'noWaitList'} />
            <span className='advance-label wait-list-input'>{__('No Waiting List', 'ticket')}</span>
          </div>
        </div>

        <div className='row btn-row text-center'>
          <hr className='advance-hr' />
          <button className='btn-link close-advance' onClick={() => {
              this.props.callbackFromParent({showingAdvance: false})
            }}>
            <i className='fa icon-up-big'></i>
            {__('Close Advance Settings', 'ticket')}
          </button>
        </div>


      </div>
    )
  }
}


export default AdvanceSettings



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/EditPoster-archieve/AdvanceSettings.js